import { ENV } from "shared-tsi";
import { environmentBase } from "./environment.base";

export const environment = {
    ...environmentBase,
    production: false,
    name : ENV.DEV,
    apiService_Auth: '/backend-login',
    apiService: '/backend-soporte',
    apiService_Erp: '/backend-api',
    apiService_Report: '/backend-report',
    apiService_Report_Lite: '/backend-report-lite',
    apiService_Export: '/backend-export',
    apiService_Produccion: '/backend-prod-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_FE: '/backend-fe',
    apiService_Notificaciones: '/backend-notification',
    apiService_Config: '/backend-config',
    recaptcha: {
        siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
    }
}